import { Capability } from '@repo/utils/auth';

/** Who opens the roll: a reader who manages lessons, or one who marks the roll. */
export const ROLL_CAPABILITIES: Capability[] = [Capability.LessonsManage, Capability.RollMark];
